import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  background-color: #fff;
  height: 100vh;
  width: 100%;
  max-width: 1920px;
  margin: auto;
  @media (min-width: 1024px) {
    display: flex;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    justify-content: start;
  }
`;
export const MainContainer = styled.div`
  flex-direction: column;
  width: 70%;
  flex-basis: 70%;
  height: 100%;
  justify-content: center;
  background-color: #fff;
  align-items: center;
  color: #000;
  display: none;
  overflow: hidden;
  p {
    font-family: "Blanco Regular";
    font-size: 20px;
    width: 40%;
  }
  img {
    height: 100%;
  }
  @media (min-width: 867px) {
    display: flex;
  }

  @media (min-width: 1112px) {
    border-radius: 20px 0 0 20px;
  }
`;
export const SideContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  height: 100%;
  justify-content: center;
  background-color: #000;
  align-items: center;
  color: #fff;
  a {
    width: fit-content;
    color: #fff;
    img {
      width: 100%;
      max-width: 75px;
    }
  }
  button {
    background-color: #ff6a00;
    width: 50%;
    height: 40px;
    border-radius: 25px;
    border-style: none;
    cursor: pointer;
    a {
      list-style: none;
      color: #fff;
      text-decoration: none;
    }
  }
  button:disabled,
  button[disabled] {
    color: #fff;
    opacity: 0.5;
    cursor: not-allowed;
  }
  h1 {
    text-align: center;
  }
  p {
    text-align: center;
  }
  @media (min-width: 867px) {
    flex-basis: 30%;
  }
`;

export const FormRegister = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  height: 50%;
  padding: 20px 0;
  div {
    display: inline;
    width: 80%;
    justify-content: center;
    align-items: center;
    margin-bottom: 1%;
    img {
      width: 10%;
      height: 60%;
      margin-right: 5%;
    }
  }
  input {
    width: calc(100% - 20px);
    background: white;
    border: 0.5px solid #000;
    padding: 15px 10px;
    margin: 5px 0px;
  }
  input::placeholder {
    color: #000;
    font-weight: bold;
    font-size: 20px;
  }
  label {
    margin: 5rem 0;
  }
  select {
    width: 100%;
    background: white;
    border: 0.5px solid #000;
    padding: 15px 0;
    margin: 5px 0px;
    border: none;
    -webkit-appearance: none;
  }
`;
